import { BaseButton } from './BaseButton';
import { ButtonGroup } from './ButtonGroup';

const Button = BaseButton as typeof BaseButton & {
  Group: typeof ButtonGroup;
};

Button.Group = ButtonGroup;

export { Button };
